import { t } from 'ember-intl';
import Heading from 'tio-reimagined/components/heading';
import Text from 'tio-reimagined/components/text';
import type { TOC } from '@ember/component/template-only';

interface QuestionsNumberedStepSignature {
  Args: {
    /** Translation key for the step number badge (e.g. "number_one") */
    number: string;
    /** Translation key for the step title */
    title: string;
    /** Translation keys for the bulleted points */
    points: string[];
    /** Optional translation key rendered as a paragraph above the list */
    intro?: string;
  };
  Element: HTMLDivElement;
}

const QuestionsNumberedStep: TOC<QuestionsNumberedStepSignature> = <template>
  <div ...attributes>
    <Heading @level={{3}} @size="base" class="flex items-center mb-2">
      <span
        class="shrink-0 w-7 h-7 tio-bg-brand text-white rounded-full inline-flex items-center justify-center text-sm font-semibold mr-3"
      >
        {{t @number}}
      </span>
      {{t @title htmlSafe=true}}
    </Heading>
    {{#if @intro}}
      <Text @tag="p" @variant="muted" class="ml-14 mb-2">
        {{t @intro}}
      </Text>
    {{/if}}
    <ul class="list-disc ml-14 space-y-2">
      {{#each @points as |point|}}
        <li>
          <Text @variant="muted">
            {{t point htmlSafe=true}}
          </Text>
        </li>
      {{/each}}
    </ul>
  </div>
</template>;

export default QuestionsNumberedStep;
